
import { getUrl as getS3AssetURL } from 'aws-amplify/storage';

export const FormFileServer = () => {
    return {
        load: (src: string, load: (blob: Blob) => void) => {
            getS3AssetURL({
                path: src,
            }).then((signedURL) => fetch(signedURL.url))
                .then(res => res.blob())
                .then(load);
        }
    }
}

export const generateS3AssetUrl = async (assetUrl: string) => {
    const signedURL = await getS3AssetURL({
        path: assetUrl,
    })
    return signedURL
}